import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExemptVendorTypeForm } from 'src/app/classes/form-groups/exempt-vendor-type-form';
import { ExemptVendorType } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { CompanyService } from 'src/app/services/company.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-add-edit-exempt-vendor-type-modal',
  templateUrl: './add-edit-exempt-vendor-type-modal.component.html',
  styleUrls: ['./add-edit-exempt-vendor-type-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AddEditExemptVendorTypeModalComponent implements OnInit {
  constructor(
    private modal: NgbActiveModal,
    private CompanyService: CompanyService,
    private route: ActivatedRoute,
    private ToastService: ToastService,
    private UtilityService: UtilityService,
    private AuthService: AuthService
  ) {}

  @Input() ExemptVendorTypeId?: number;

  title: string = 'Exempt Vendor Type';
  exemptVendorTypeForm: ExemptVendorTypeForm = new ExemptVendorTypeForm();

  cancel() {
    this.modal.close(false);
  }

  save() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.exemptVendorTypeForm
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot save Exempt Vendor Type. There are errors in the form.',
        { returnError: true }
      );
    }

    const ExemptVendorType = this.exemptVendorTypeForm.getRawValue();

    if (!ExemptVendorType.id) {
      Object.assign(ExemptVendorType, {
        CompanyId: this.AuthService.getUserCompanyId()
      });
    }

    this.CompanyService.saveCompanyExemptVendorType(ExemptVendorType).subscribe(
      {
        next: (ExemptVendorType: ExemptVendorType) => {
          if (ExemptVendorType) {
            this.ToastService.addSuccessToast(
              'Success',
              'Successfully saved ExemptVendorType.'
            );
            this.modal.close(true);
          }
        }
      }
    );
  }

  ngOnInit(): void {
    if (this.ExemptVendorTypeId) {
      this.title = `Edit ${this.title}`;

      this.CompanyService.getCompanyExemptVendorType({
        id: this.ExemptVendorTypeId
      }).subscribe({
        next: (ExemptVendorType: ExemptVendorType) => {
          if (ExemptVendorType) {
            this.exemptVendorTypeForm.patchValue(ExemptVendorType);
          }
        }
      });
    } else {
      this.title = `Add ${this.title}`;
    }
  }
}
